module.exports = __webpack_public_path__ + "static/img/16.0d3fc9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/16.png
// module id = Zz0w
// module chunks = 0